module.exports = __webpack_public_path__ + "7fe5a54205e1808b45c7a8dcb6bca54d.png";